export interface MangaChapter {
  id: number;
  title: string;
  updatedAt: string;
}

export interface Manga {
  id: number;
  title: string;
  cover: string;
  author: string;
  category: 'kr' | 'jp' | 'cn';
  status: string;
  description: string;
  tags: string[];
  rating: number;
  views: number;
  chapters: MangaChapter[];
  updatedAt: string;
  isHot: boolean;
}

export const mangaList: Manga[] = [
  {
    id: 1,
    title: '社内恋爱',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%20style%2C%20beautiful%20female%20character%20in%20office%20setting%2C%20soft%20warm%20lighting%2C%20delicate%20illustration%2C%20clean%20background%2C%20professional%20manhwa%20cover%20with%20Korean%20aesthetic&width=400&height=560&seq=manga-cover-01&orientation=portrait',
    author: '李智恩',
    category: 'kr',
    status: '连载中',
    description: '在大公司工作的平凡职员金秀雅，意外与公司最年轻的部长展开了秘密办公室恋情。两人从最初的互相试探，到逐渐靠近的心动瞬间，甜蜜又刺激的社内恋爱故事就此展开！面对职场压力与感情纠葛，他们能否守住这份来之不易的爱情？',
    tags: ['恋爱', '职场', '甜宠', '都市'],
    rating: 9.2,
    views: 1285000,
    chapters: [
      { id: 1, title: '第1话 新来的部长', updatedAt: '2026-08-01' },
      { id: 2, title: '第2话 意外的偶遇', updatedAt: '2026-08-01' },
      { id: 3, title: '第3话 心跳加速', updatedAt: '2026-08-02' },
      { id: 4, title: '第4话 秘密约会', updatedAt: '2026-08-02' },
      { id: 5, title: '第5话 危机来临', updatedAt: '2026-08-03' },
    ],
    updatedAt: '2026-08-03',
    isHot: true,
  },
  {
    id: 2,
    title: '恶魔的契约',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20manhwa%20cover%2C%20mysterious%20male%20character%20with%20red%20eyes%2C%20supernatural%20romance%2C%20dramatic%20lighting%2C%20gothic%20aesthetic%2C%20clean%20dark%20background%2C%20Korean%20webtoon%20style&width=400&height=560&seq=manga-cover-02&orientation=portrait',
    author: '朴星辰',
    category: 'kr',
    status: '连载中',
    description: '为了拯救病重的妹妹，少女林月与神秘恶魔签订了契约。然而她不知道的是，这个契约将彻底改变她的命运。在黑暗与光明之间徘徊，她逐渐发现恶魔背后隐藏的惊天秘密……一段跨越人魔两界的禁忌之恋就此展开！',
    tags: ['奇幻', '恋爱', '悬疑', '暗黑'],
    rating: 9.5,
    views: 2150000,
    chapters: [
      { id: 1, title: '第1话 绝望之夜', updatedAt: '2026-08-01' },
      { id: 2, title: '第2话 契约成立', updatedAt: '2026-08-01' },
      { id: 3, title: '第3话 恶魔的温柔', updatedAt: '2026-08-02' },
      { id: 4, title: '第4话 隐藏的真相', updatedAt: '2026-08-03' },
    ],
    updatedAt: '2026-08-03',
    isHot: true,
  },
  {
    id: 3,
    title: '校园风云录',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20school%20life%20cover%2C%20energetic%20students%20in%20uniform%2C%20youth%20comedy%20style%2C%20bright%20colorful%20illustration%2C%20clean%20white%20background%2C%20modern%20Chinese%20comic%20style&width=400&height=560&seq=manga-cover-03&orientation=portrait',
    author: '陈小北',
    category: 'cn',
    status: '已完结',
    description: '平凡高中生叶辰意外获得神秘系统，从此校园生活天翻地覆！从班级倒数到全校第一，从默默无闻到风云人物。搞笑、热血、青春，这部校园漫画带你重温最美好的学生时代！',
    tags: ['校园', '搞笑', '热血', '系统流'],
    rating: 8.9,
    views: 1890000,
    chapters: [
      { id: 1, title: '第1话 系统的降临', updatedAt: '2026-07-15' },
      { id: 2, title: '第2话 第一次任务', updatedAt: '2026-07-16' },
      { id: 3, title: '第3话 学霸之路', updatedAt: '2026-07-18' },
      { id: 4, title: '第4话 校园偶像', updatedAt: '2026-07-20' },
      { id: 5, title: '第5话 最终考验', updatedAt: '2026-07-22' },
      { id: 6, title: '第6话 毕业时刻（完）', updatedAt: '2026-07-25' },
    ],
    updatedAt: '2026-07-25',
    isHot: true,
  },
  {
    id: 4,
    title: '东京恋爱物语',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20romance%20cover%2C%20cherry%20blossom%20scene%2C%20high%20school%20couple%2C%20soft%20pink%20tones%2C%20shojo%20manga%20style%2C%20clean%20simple%20background%2C%20delicate%20line%20art&width=400&height=560&seq=manga-cover-04&orientation=portrait',
    author: '山田花子',
    category: 'jp',
    status: '连载中',
    description: '在樱花纷飞的东京，来自乡下的少女小樱与冷漠的天才少年佐藤相遇了。两个性格截然不同的人，在高中生活中慢慢靠近。这是一部温暖治愈的纯爱漫画，带你感受最纯粹的青春悸动。',
    tags: ['恋爱', '校园', '治愈', '纯爱'],
    rating: 9.0,
    views: 1560000,
    chapters: [
      { id: 1, title: '第1话 樱花下的相遇', updatedAt: '2026-08-01' },
      { id: 2, title: '第2话 图书馆的秘密', updatedAt: '2026-08-02' },
      { id: 3, title: '第3话 夏日的烟火', updatedAt: '2026-08-03' },
    ],
    updatedAt: '2026-08-03',
    isHot: true,
  },
  {
    id: 5,
    title: '修真聊天群',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20manhua%20cover%2C%20xianxia%20fantasy%2C%20martial%20artist%20character%20with%20flowing%20robes%2C%20ancient%20Chinese%20aesthetic%2C%20mystical%20atmosphere%2C%20clean%20background%2C%20modern%20manhua%20art&width=400&height=560&seq=manga-cover-05&orientation=portrait',
    author: '墨香铜臭',
    category: 'cn',
    status: '连载中',
    description: '普通大学生宋书航某天被拉入了一个修真聊天群，群里都是真正的修真者！从此他的日常变得不再平凡。当九州第一金丹修士成了他的网友，当修仙界的各种大佬在群里日常水群，宋书航的修真之路注定与众不同！',
    tags: ['修仙', '搞笑', '都市', '系统流'],
    rating: 9.3,
    views: 3200000,
    chapters: [
      { id: 1, title: '第1话 神秘的群聊', updatedAt: '2026-08-01' },
      { id: 2, title: '第2话 前辈好！', updatedAt: '2026-08-01' },
      { id: 3, title: '第3话 第一次修炼', updatedAt: '2026-08-02' },
      { id: 4, title: '第4话 丹药初体验', updatedAt: '2026-08-02' },
      { id: 5, title: '第5话 群友面基', updatedAt: '2026-08-03' },
    ],
    updatedAt: '2026-08-03',
    isHot: true,
  },
  {
    id: 6,
    title: '重生之都市仙尊',
    cover: 'https://readdy.ai/api/search-image?query=Rebirth%20cultivation%20manhua%20cover%2C%20powerful%20male%20protagonist%20in%20modern%20city%2C%20martial%20arts%20fantasy%2C%20dramatic%20pose%2C%20urban%20background%2C%20Chinese%20manhua%20style%2C%20clean%20composition&width=400&height=560&seq=manga-cover-06&orientation=portrait',
    author: '天蚕土豆',
    category: 'cn',
    status: '连载中',
    description: '一代仙尊重生回到高中时代，带着前世的记忆和修为，他誓要弥补所有遗憾。前世辜负的人，今生加倍偿还；前世敌人，今生统统踩在脚下。且看仙尊如何在都市中纵横捭阖，重登巅峰！',
    tags: ['重生', '修仙', '都市', '爽文'],
    rating: 8.7,
    views: 2450000,
    chapters: [
      { id: 1, title: '第1话 仙尊归来', updatedAt: '2026-08-01' },
      { id: 2, title: '第2话 昔日仇敌', updatedAt: '2026-08-02' },
      { id: 3, title: '第3话 校园立威', updatedAt: '2026-08-03' },
    ],
    updatedAt: '2026-08-03',
    isHot: true,
  },
  {
    id: 7,
    title: '魔女的诱惑',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20manhwa%20cover%2C%20beautiful%20witch%20character%2C%20magical%20elements%2C%20mysterious%20atmosphere%2C%20warm%20dramatic%20lighting%2C%20soft%20color%20palette%2C%20clean%20background&width=400&height=560&seq=manga-cover-07&orientation=portrait',
    author: '金敏智',
    category: 'kr',
    status: '完结',
    description: '在魔法与人类共存的世界里，最强魔女艾琳厌倦了永恒的生命。直到她遇见了一个平凡的人类少年，他的纯真与善良让魔女的心再次跳动。然而跨越种族的爱情注定坎坷，她们能否冲破世俗的枷锁？',
    tags: ['奇幻', '恋爱', '魔法', '治愈'],
    rating: 9.4,
    views: 1980000,
    chapters: [
      { id: 1, title: '第1话 永恒的生命', updatedAt: '2026-07-10' },
      { id: 2, title: '第2话 平凡的少年', updatedAt: '2026-07-12' },
      { id: 3, title: '第3话 心动的魔法', updatedAt: '2026-07-15' },
      { id: 4, title: '第4话 最后的抉择（完）', updatedAt: '2026-07-18' },
    ],
    updatedAt: '2026-07-18',
    isHot: false,
  },
  {
    id: 8,
    title: '剑与魔法学院',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20fantasy%20manga%20cover%2C%20magic%20academy%20students%2C%20sword%20and%20magic%20theme%2C%20action%20pose%2C%20vibrant%20colors%2C%20clean%20white%20background%2C%20shonen%20manga%20style&width=400&height=560&seq=manga-cover-08&orientation=portrait',
    author: '佐藤健',
    category: 'jp',
    status: '连载中',
    description: '平凡少年艾伦意外被剑与魔法学院录取，从此开启了热血沸腾的魔法冒险之旅！在最顶级的魔法学院里，他结识了志同道合的伙伴，一起对抗黑暗势力，揭开学院隐藏千年的秘密！',
    tags: ['冒险', '魔法', '热血', '校园'],
    rating: 9.1,
    views: 1750000,
    chapters: [
      { id: 1, title: '第1话 入学通知书', updatedAt: '2026-08-01' },
      { id: 2, title: '第2话 分班测试', updatedAt: '2026-08-02' },
      { id: 3, title: '第3话 第一个任务', updatedAt: '2026-08-03' },
      { id: 4, title: '第4话 黑暗来袭', updatedAt: '2026-08-03' },
    ],
    updatedAt: '2026-08-03',
    isHot: false,
  },
  {
    id: 9,
    title: '千金归来',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20drama%20manhwa%20cover%2C%20elegant%20female%20lead%20in%20luxurious%20setting%2C%20revenge%20theme%2C%20sophisticated%20art%20style%2C%20warm%20golden%20tones%2C%20clean%20background%2C%20modern%20Korean%20webtoon&width=400&height=560&seq=manga-cover-09&orientation=portrait',
    author: '崔秀英',
    category: 'kr',
    status: '连载中',
    description: '被继母和继妹陷害而失去一切的千金小姐沈明珠，在绝境中获得重生。她化身神秘投资人华丽归来，誓要夺回属于自己的一切！一场豪门恩怨、爱恨情仇的大戏就此拉开序幕。',
    tags: ['复仇', '豪门', '恋爱', '都市'],
    rating: 9.0,
    views: 1680000,
    chapters: [
      { id: 1, title: '第1话 坠入深渊', updatedAt: '2026-08-01' },
      { id: 2, title: '第2话 绝处逢生', updatedAt: '2026-08-02' },
      { id: 3, title: '第3话 华丽回归', updatedAt: '2026-08-03' },
    ],
    updatedAt: '2026-08-03',
    isHot: true,
  },
  {
    id: 10,
    title: '异世界食堂',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20isekai%20manga%20cover%2C%20cozy%20restaurant%20in%20fantasy%20world%2C%20food%20themed%2C%20warm%20atmosphere%2C%20various%20fantasy%20characters%2C%20soft%20lighting%2C%20clean%20composition%2C%20slice%20of%20life&width=400&height=560&seq=manga-cover-10&orientation=portrait',
    author: '犬塚惇平',
    category: 'jp',
    status: '已完结',
    description: '在异世界的角落，有一家只在周六营业的神秘餐厅。门连接着不同的世界，来自各族的客人们在这里品尝着来自另一个世界的美食。每一道菜背后，都有一个温暖人心的故事。',
    tags: ['美食', '异世界', '治愈', '日常'],
    rating: 9.3,
    views: 1350000,
    chapters: [
      { id: 1, title: '第1话 周六的客人', updatedAt: '2026-07-01' },
      { id: 2, title: '第2话 龙族的蛋包饭', updatedAt: '2026-07-05' },
      { id: 3, title: '第3话 精灵的咖喱', updatedAt: '2026-07-10' },
      { id: 4, title: '第4话 矮人的啤酒', updatedAt: '2026-07-15' },
      { id: 5, title: '第5话 最后的晚餐（完）', updatedAt: '2026-07-20' },
    ],
    updatedAt: '2026-07-20',
    isHot: false,
  },
  {
    id: 11,
    title: '绝世武魂',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manhua%20cover%2C%20young%20warrior%20with%20sword%2C%20ancient%20Chinese%20fantasy%2C%20dynamic%20action%20pose%2C%20dramatic%20lighting%2C%20clean%20background%2C%20wuxia%20aesthetic&width=400&height=560&seq=manga-cover-11&orientation=portrait',
    author: '洛城东',
    category: 'cn',
    status: '连载中',
    description: '少年秦尘身怀绝世武魂却无法觉醒，被视为废物的他受尽冷眼。直到那一天，武魂终于觉醒，从此一飞冲天！且看少年如何从最底层崛起，横扫天下，成就无上霸业！',
    tags: ['玄幻', '热血', '逆袭', '战斗'],
    rating: 8.8,
    views: 2800000,
    chapters: [
      { id: 1, title: '第1话 废物之名', updatedAt: '2026-08-01' },
      { id: 2, title: '第2话 武魂觉醒', updatedAt: '2026-08-01' },
      { id: 3, title: '第3话 初露锋芒', updatedAt: '2026-08-02' },
      { id: 4, title: '第4话 宗门大比', updatedAt: '2026-08-03' },
    ],
    updatedAt: '2026-08-03',
    isHot: true,
  },
  {
    id: 12,
    title: '邻家的天使大人',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20slice%20of%20life%20manga%20cover%2C%20cute%20girl%20next%20door%2C%20school%20life%20romance%2C%20soft%20pastel%20colors%2C%20warm%20sunlight%2C%20clean%20simple%20background%2C%20shojo%20aesthetic&width=400&height=560&seq=manga-cover-12&orientation=portrait',
    author: '佐伯さん',
    category: 'jp',
    status: '连载中',
    description: '独居高中生藤宫周的生活被隔壁搬来的"天使"彻底改变。她美丽、温柔、完美无缺，却在生活中意外地笨拙。两个孤独的灵魂在朝夕相处中慢慢靠近，一段甜蜜又温馨的邻里恋爱故事！',
    tags: ['恋爱', '日常', '治愈', '校园'],
    rating: 9.4,
    views: 2100000,
    chapters: [
      { id: 1, title: '第1话 新邻居', updatedAt: '2026-08-01' },
      { id: 2, title: '第2话 雨天的伞', updatedAt: '2026-08-02' },
      { id: 3, title: '第3话 便当的温暖', updatedAt: '2026-08-03' },
    ],
    updatedAt: '2026-08-03',
    isHot: false,
  },
];

export const getMangaById = (id: number): Manga | undefined => {
  return mangaList.find((m) => m.id === id);
};

export const getMangaByCategory = (category: string): Manga[] => {
  return mangaList.filter((m) => m.category === category);
};

export const getHotManga = (): Manga[] => {
  return mangaList.filter((m) => m.isHot);
};

export const getLatestManga = (count: number = 8): Manga[] => {
  return [...mangaList]
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, count);
};

export const getTopRatedManga = (count: number = 10): Manga[] => {
  return [...mangaList]
    .sort((a, b) => b.rating - a.rating)
    .slice(0, count);
};

export const categoryMap: Record<string, string> = {
  kr: '韩漫',
  jp: '日漫',
  cn: '国漫',
};

export const categoryRoutes: Record<string, string> = {
  kr: 'kr',
  jp: 'jp',
  cn: 'cn',
};